/* Skapad av Claude Code — SVD Timeline v2 (accordion) */
(function () {
  'use strict';

  function initRoot(root) {
    if (root.dataset.tl2Inited === 'true') return;
    root.dataset.tl2Inited = 'true';

    const singleOpen = root.dataset.singleOpen !== 'false';
    const rows = root.querySelectorAll('.tl2-row');

    function closeItem(item) {
      item.dataset.open = 'false';
      const btn = item.querySelector('.tl2-row');
      const panel = item.querySelector('.tl2-panel');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      if (panel) panel.setAttribute('aria-hidden', 'true');
    }

    function openItem(item) {
      item.dataset.open = 'true';
      const btn = item.querySelector('.tl2-row');
      const panel = item.querySelector('.tl2-panel');
      if (btn) btn.setAttribute('aria-expanded', 'true');
      if (panel) panel.setAttribute('aria-hidden', 'false');
    }

    rows.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const item = btn.closest('.tl2-item');
        if (!item) return;
        const isOpen = item.dataset.open === 'true';

        if (singleOpen) {
          root.querySelectorAll('.tl2-item').forEach(closeItem);
          if (!isOpen) openItem(item);
          // Om vi klickade på den redan öppna i single-läge → alla stängda
        } else {
          if (isOpen) closeItem(item);
          else openItem(item);
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.tl2-root').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify Customizer: ny instans när sektionen laddas om
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.tl2-root').forEach(function (root) {
      root.dataset.tl2Inited = 'false';
      initRoot(root);
    });
  });
})();
